import React from 'react';
import PropTypes from 'prop-types';

function GooglePayIcon({ className, monochrome, w, h }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 68 36"
      className={className}
    >
      <g>
        <path d="M32.6 18.8v6.6h-2V9.2H36a4.8 4.8 0 0 1 3.5 1.4 4.7 4.7 0 0 1 .2 6.6l-.2.3c-1 .9-2.1 1.3-3.5 1.3h-3.4zm0-7.6v5.7H36c.8 0 1.5-.3 2-.9 1.1-1.1 1-3 0-4a2.8 2.8 0 0 0-2-.8h-3.4zm13 2.8a5 5 0 0 1 3.7 1.2c.8.8 1.3 2 1.3 3.4v6.8h-2v-1.5c-1 1.2-2 1.9-3.5 1.9-1.2 0-2.2-.4-3-1.1A3.4 3.4 0 0 1 41 22c0-1.2.4-2 1.3-2.8.8-.7 2-1 3.4-1 1.2 0 2.2.2 3 .7v-.5c0-.7-.3-1.4-.8-1.8a3 3 0 0 0-2-.8c-1.1 0-2 .5-2.7 1.5L41.3 16a5 5 0 0 1 4.4-2.1zM43 22c0 .5.3 1 .7 1.4a2.5 2.5 0 0 0 1.6.5c.8 0 1.7-.4 2.3-1a3 3 0 0 0 1-2.3 4 4 0 0 0-2.7-.7c-.8 0-1.5.2-2 .6-.6.4-.9.9-.9 1.5zm18.8-7.7l-6.8 16h-2.1l2.5-5.6-4.5-10.4h2.2l3.3 8 3.2-8z" />
        <path
          fill={monochrome ? '#353535' : '#4285F4'}
          d="M24.3 17.4l-.1-1.9h-8.7v3.6h5a4.3 4.3 0 0 1-1.9 2.8v2.4h3c1.7-1.7 2.7-4 2.7-6.9z"
        />
        <path
          fill={monochrome ? '#5D5D5D' : '#34A853'}
          d="M15.5 26.5c2.5 0 4.6-.8 6-2.2l-2.9-2.4c-.8.6-1.8 1-3 1a5.5 5.5 0 0 1-5.2-4h-3v2.5a9.1 9.1 0 0 0 8.1 5.1z"
        />
        <path
          fill={monochrome ? '#ACACAC' : '#FBBC04'}
          d="M10.4 19a5.7 5.7 0 0 1 0-3.6V13h-3a9.3 9.3 0 0 0 0 8.4l3-2.4z"
        />
        <path
          fill={monochrome ? '#888' : '#EA4335'}
          d="M15.5 11.6A4.9 4.9 0 0 1 19 13l2.7-2.7A8.8 8.8 0 0 0 15.5 8C12.1 8 9 10 7.4 13l3 2.4a5.5 5.5 0 0 1 5.1-3.8z"
        />
      </g>
    </svg>
  );
}

GooglePayIcon.propTypes = {
  className: PropTypes.string,
  monochrome: PropTypes.bool,
  w: PropTypes.number,
  h: PropTypes.number,
};

GooglePayIcon.defaultProps = {
  w: 68,
  h: 36,
};

export default GooglePayIcon;
